export default "__VITE_ASSET__64435ef7__"